module.exports = __webpack_public_path__ + "static/img/y38.b2edfca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y38.jpg
// module id = 4VHM
// module chunks = 1